export var Country;
(function (Country) {
    // ARGENTINA = 'ARGENTINA',
    Country["AUSTRALIA"] = "AUSTRALIA";
    // BAHRAIN = 'BAHRAIN',
    // BELARUS = 'BELARUS',
    // BELGIUM = 'BELGIUM',
    // BOLIVIA = 'BOLIVIA',
    // BRAZIL = 'BRAZIL',
    Country["CANADA"] = "CANADA";
    // CHILE = 'CHILE',
    Country["CHINA"] = "CHINA";
    // COLOMBIA = 'COLOMBIA',
    // CZECHIA = 'CZECHIA',
    Country["DENMARK"] = "DENMARK";
    Country["FINLAND"] = "FINLAND";
    Country["FRANCE"] = "FRANCE";
    Country["GERMANY"] = "GERMANY";
    // GHANA = 'GHANA',
    // GREECE = 'GREECE',
    Country["HONG_KONG"] = "HONG_KONG";
    Country["HUNGARY"] = "HUNGARY";
    Country["ICELAND"] = "ICELAND";
    // INDIA = 'INDIA',
    // INDONESIA = 'INDONESIA',
    Country["IRELAND"] = "IRELAND";
    // ITALY = 'ITALY',
    Country["JAPAN"] = "JAPAN";
    // KAZAKHSTAN = 'KAZAKHSTAN',
    // MACAO = 'MACAO',
    // MALAYSIA = 'MALAYSIA',
    // MEXICO = 'MEXICO',
    // MONACO = 'MONACO',
    // MOZAMBIQUE = 'MOZAMBIQUE',
    // MYANMAR = 'MYANMAR',
    Country["NETHERLANDS"] = "NETHERLANDS";
    Country["NEW_ZEALAND"] = "NEW_ZEALAND";
    Country["NORWAY"] = "NORWAY";
    // OMAN = 'OMAN',
    // PANAMA = 'PANAMA',
    // PERU = 'PERU',
    // PHILIPPINES = 'PHILIPPINES',
    // POLAND = 'POLAND',
    // QATAR = 'QATAR',
    // ROMANIA = 'ROMANIA',
    // RUSSIAN_FEDERATION = 'RUSSIAN_FEDERATION',
    Country["SAUDI_ARABIA"] = "SAUDI_ARABIA";
    Country["SINGAPORE"] = "SINGAPORE";
    // SLOVAKIA = 'SLOVAKIA',
    // SOUTH_AFRICA = 'SOUTH_AFRICA',
    Country["SPAIN"] = "SPAIN";
    // SRI_LANKA = 'SRI_LANKA',
    Country["SWEDEN"] = "SWEDEN";
    // SWITZERLAND = 'SWITZERLAND',
    // TAIWAN = 'TAIWAN',
    // THAILAND = 'THAILAND',
    // TRINIDAD_AND_TOBAGO = 'TRINIDAD_AND_TOBAGO',
    // UKRAINE = 'UKRAINE',
    Country["UNITED_ARAB_EMIRATES"] = "UNITED_ARAB_EMIRATES";
    Country["UNITED_KINGDOM"] = "UNITED_KINGDOM";
    Country["UNITED_STATES"] = "UNITED_STATES";
    // VIETNAM = 'VIETNAM',
    Country["OTHER"] = "OTHER";
})(Country || (Country = {}));
export var ProjectSpecification;
(function (ProjectSpecification) {
    ProjectSpecification["BREEAM"] = "BREEAM";
    ProjectSpecification["SKOK"] = "SKOK";
    ProjectSpecification["CANTEEN"] = "CANTEEN";
    ProjectSpecification["JCT"] = "JCT";
    ProjectSpecification["FIDIC_SILVER_BOOK"] = "FIDIC_SILVER_BOOK";
    ProjectSpecification["FIDIC_PINK_BOOK"] = "FIDIC_PINK_BOOK";
    ProjectSpecification["FIDIC_RED_BOOK"] = "FIDIC_RED_BOOK";
    ProjectSpecification["FIDIC_YELLOW_BOOK_1ST_EDITION_1999"] = "FIDIC_YELLOW_BOOK_1ST_EDITION_1999";
    ProjectSpecification["FIDIC_YELLOW_BOOK_2017"] = "FIDIC_YELLOW_BOOK_2017";
})(ProjectSpecification || (ProjectSpecification = {}));
export var ProjectConstructionType;
(function (ProjectConstructionType) {
    ProjectConstructionType["OFFICE_BUILDING"] = "OFFICE_BUILDING";
    ProjectConstructionType["RESIDENTIAL_BUILDING"] = "RESIDENTIAL_BUILDING";
    ProjectConstructionType["HOSPITAL"] = "HOSPITAL";
    ProjectConstructionType["DATA_CENTER"] = "DATA_CENTER";
    ProjectConstructionType["OTHER_BUILDING"] = "OTHER_BUILDING";
    ProjectConstructionType["BRIDGE"] = "BRIDGE";
    ProjectConstructionType["ROAD"] = "ROAD";
    ProjectConstructionType["HOTEL"] = "HOTEL";
    ProjectConstructionType["OTHER_INFRASTRUCTURE"] = "OTHER_INFRASTRUCTURE";
})(ProjectConstructionType || (ProjectConstructionType = {}));
export const INFRASTRUCTURE_ONLY_CONSTRUCTION_TYPES = [
    ProjectConstructionType.OTHER_INFRASTRUCTURE,
    ProjectConstructionType.ROAD,
    ProjectConstructionType.BRIDGE,
];
export var ProjectInvoiceTo;
(function (ProjectInvoiceTo) {
    ProjectInvoiceTo["ORGANIZATION"] = "ORGANIZATION";
    ProjectInvoiceTo["PROJECT"] = "PROJECT";
})(ProjectInvoiceTo || (ProjectInvoiceTo = {}));
export var ProjectRole;
(function (ProjectRole) {
    ProjectRole["ADMIN"] = "ADMIN";
    ProjectRole["USER"] = "USER";
})(ProjectRole || (ProjectRole = {}));
